import { Link } from "react-router-dom";
import { useAppDispatch } from "../../../../../ReduxToolkit/Hooks";
import { ModalButtonsProp, ProductItemInterface } from "../../../../../Types/EcommerceType";
import { addToCartData } from "../../../../../ReduxToolkit/Reducers/ECommerce/CartSlice";
import { AddToCartButton, ViewDetails } from "../../../../../Constants/Constants";

export const ModalButtons:React.FC<ModalButtonsProp> = ({ singleProduct, quantity }) => {
  const dispatch = useAppDispatch();
  const AddToCarts = (item: ProductItemInterface) => dispatch(addToCartData({ item, quantity }));

  return (
    <div className="addcart-btn">
      <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/cart`} className="btn btn-primary text-white me-2" onClick={() => AddToCarts(singleProduct)}>
        {AddToCartButton}
      </Link>
      <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/product_page`} className="btn btn-primary text-white">
        {ViewDetails}
      </Link>
    </div>
  );
};
